import React, { useState, useEffect, useContext } from 'react'
import io from "socket.io-client";
import {IsLoggedContext} from '../Store'
import '../styles/styles.css'
import { Link } from 'react-router-dom'
import VideoChat from './VideoChat'

let socket = io.connect('https://clusterfy.herokuapp.com');
const SpaceChat = (props) => {
    const spaceName = props.match.params.spaceName
    const [messages, setMessages] = useState([""]);
    const [message, setMessage] = useState("");
    const [isLogged] = useContext(IsLoggedContext)

    useEffect(() => {

        const getMessages = () => {
          socket.on("message", msg => {
      
            setMessages([...messages, msg]);
          });
        };
    
    
      
      socket.on('join')
        //createGame()
        //sendMsg()
        getMessages()
      
      }, [messages, message])

      const onChange = e => {
        setMessage(e.target.value);
      };

      const handleSubmit = (event) => {
        event.preventDefault()
        if (message !== "") {
          // 
          socket.emit('join', {message: isLogged + ": " + message, room: spaceName})
           setMessage("");
         } else {
           alert("Please Add A Message");
         }
      }

      const rightText = (text) => {
        const wordStyle = {
        overflowWrap: 'break-word',
        wordWrap: 'break-word',
        wordBreak: 'break-all',
        hyphens: 'auto',
  }
      if(text === 'Chat Help'){
        return(
          <div className="level-item">
          <p className="has-text-danger">
            {text}
          </p>
          </div>
        )
      } else {
        const name = text.indexOf(": ")
        const strippedText = text.substring(name+1)
        const sender = text.substring(0, name)
        return(
        <div style={{paddingLeft: '1%'}}>
          <b>
            {sender}
          </b>
          <p style={wordStyle}>
            {strippedText}
          </p>
        </div>
        )
      }
    }

    return (
        <>
                <div className="hero is-primary">
			<div className="hero-body">
				<div className="container">
					<div className="level-left">
						<h1 className="title">
                            {spaceName}
						</h1>
					</div>
					<div className="level-left">
						<h2 className="subtitle">
                            description
						</h2>
					</div>
				</div>
			</div>
		</div>
        <div className="level">
            <div className="level-left">
                Reminders
            </div>
            <div className="level-item">
            <Link className="link" to={ {
              pathname: `/space/${spaceName}/chat`}}>Chat</Link>            
            </div>
            <div className="level-right">
            <Link className="link" to={ {
              pathname: `/space/${spaceName}/members`}}>Members</Link>   
            </div>
        </div>
        <div>
          <div className="level-item">
            Say something or create a video call with {spaceName}
          </div>
          <div className="level-item">
          <VideoChat person={spaceName}/>
          </div>
<div className="sticky">
              
            
              <div>
                <div>
                <form onSubmit={handleSubmit}>
                  <div>
                    <div>
                      <div>
                      <div>
                      <input value={message} placeholder="Say something nice..." name="message" 
                      className="input" style={{position: 'fixed', bottom: 5, width: '100%'}} onChange={e => onChange(e)} />
                      </div>
                    </div>
                    
                  
                 </div>
              
            {messages.length > 0 &&
            messages.map((msg,i) => (
            <ul key={i}>
                <li key={i}>
                <div key={i}>
                  {rightText(msg)}
                </div>
                </li>
            </ul>
          ))}
           </div>
        </form>
        
        </div>
        
      </div>

     </div>
    </div>
        </>
    )
}

export default SpaceChat